import http from "../httpService";
import {getBaseUrl} from "../../config";


export const getRequestBranch = id => {
  return http.get(
    `${getBaseUrl()}/request_branch/${id}`
  );
};

export const getAgentRequestBranchs = agent_id => {
  return http.get(
    `${getBaseUrl()}/agent_request_branchs/${agent_id}`
  );
};

export const getRequestBranchs = () => {
  return http.get(
    `${getBaseUrl()}/agent_request_branch`
  );
};